<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Veículos</div>


  <button mat-button class="btn-add" (click)="addFrot()">Novo Veículo</button>


</div>

<mat-tab-group animationDuration="400ms">
  @if (checkPermission('paginado', 'legal')) {
  <mat-tab label="Frota" [disabled]="!checkPermission('paginado', 'legal')">
    <!--  <mat-tab label="Jurídico">-->
    <vehicle-tg [listRefresh]="uploadList"></vehicle-tg>
  </mat-tab>
  }
  <!--  <mat-tab label="Fisico" disabled>-->
  <!--    <individual-client></individual-client>-->
  <!--  </mat-tab>-->
  @if (checkPermission('paginado', 'sub')) {
  <mat-tab label="Veículo Fornecedor" [disabled]="!checkPermission('paginado', 'sub')">
    <vehicle-supplier [listRefresh]="uploadList"></vehicle-supplier>
  </mat-tab>
  }
</mat-tab-group>